import BaseEvent from 'ol/events/Event';
import { CommonEvents } from './CommonEvents';
import PreUndoData from './PreUndoData';

export default class PreUndoEvent extends BaseEvent {
    name: string
    data: PreUndoData[]
    constructor(data: PreUndoData[], name: string) {
        super(CommonEvents.PreUndo)
        this.data = data
        this.name = name
    }
}